import { Loader2 } from "lucide-react";
import { Progress } from "./progress";

interface ProcessingOverlayProps {
	isProcessing: boolean;
	progress?: number;
	status?: string;
	message?: string;
}

export const ProcessingOverlay = ({
	isProcessing,
	progress,
	status,
	message = "Processing..."
}: ProcessingOverlayProps) => {
	if (!isProcessing)
		return null;

	return (
		<div
			role="status"
			aria-live="polite"
			className="absolute inset-0 z-[9999] flex items-center justify-center bg-background/75 backdrop-blur-[2px] animate-in fade-in-0 duration-200"
		>
			<div className="w-full max-w-sm mx-4 rounded-sm border bg-card text-card-foreground shadow-lg p-5 animate-in zoom-in-95 fade-in-0 duration-200">
				<div className="flex items-center gap-3">
					<div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10">
						<Loader2 className="h-5 w-5 text-primary animate-spin" />
					</div>
					<div className="min-w-0">
						<p className="text-sm font-semibold leading-tight">{message}</p>
						{status && (
							<p className="mt-0.5 text-xs text-muted-foreground truncate">{status}</p>
						)}
					</div>
				</div>

				{progress !== undefined && (
					<div className="mt-4 flex items-center gap-3">
						<Progress value={progress} className="h-1.5 flex-1 rounded-full bg-muted [&>div]:rounded-full" />
						<span className="w-9 text-right text-xs tabular-nums text-muted-foreground">{Math.round(progress)}%</span>
					</div>
				)}
			</div>
		</div>
	);
};
